import { deserialize, serializable } from 'serializr';
import { Deserializable } from './deserializable';

export class Sort implements Deserializable {
  @serializable
  public sorted: boolean;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Sort, input));
  }
}
